// Typeahead Helper - Handle typeahead dropdown behavior
export function initTypeaheadHelper() {
  let forceCloseMenus = new Set(); // Track menus that should stay closed
  
  function forceCloseMenu(menu) {
    if (!menu) return;
    menu.style.display = 'none';
    menu.style.visibility = 'hidden';
    menu.classList.remove('has-suggestions');
    forceCloseMenus.add(menu);
    
    // Remove from force close set after a delay
    setTimeout(() => {
      forceCloseMenus.delete(menu);
    }, 2000);
  }
  
  function checkTypeaheadMenu(menu) {
    if (!menu) return;
    
    // If this menu is in the force close set, keep it closed
    if (forceCloseMenus.has(menu)) {
      menu.style.display = 'none';
      menu.style.visibility = 'hidden';
      return;
    }
    
    // Check if menu has any non-empty suggestions
    const suggestions = menu.querySelectorAll('.tt-suggestion');
    const hasSuggestions = suggestions.length > 0;
    
    // Check if any datasets have content
    const datasets = menu.querySelectorAll('.tt-dataset');
    const hasContent = Array.from(datasets).some(dataset => 
      dataset.children.length > 0 && 
      dataset.textContent.trim().length > 0
    );
    
    if (hasSuggestions || hasContent) {
      menu.classList.add('has-suggestions');
      menu.style.display = 'block';
      menu.style.visibility = 'visible';
    } else {
      menu.classList.remove('has-suggestions');
      menu.style.display = 'none';
      menu.style.visibility = 'hidden';
    }
  }
  
  // Monitor all typeahead menus
  function monitorTypeaheadMenus() {
    const menus = document.querySelectorAll('.tt-menu, .tt-dropdown-menu');
    menus.forEach(checkTypeaheadMenu);
  }
  
  // Set up mutation observer to watch for changes in typeahead menus
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.target.classList.contains('tt-menu') || 
          mutation.target.classList.contains('tt-dropdown-menu') ||
          mutation.target.classList.contains('tt-dataset')) {
        const menu = mutation.target.closest('.tt-menu, .tt-dropdown-menu');
        checkTypeaheadMenu(menu);
      }
    });
  });
  
  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });
  
  // Initial check
  monitorTypeaheadMenus();
  
  // Check periodically but less frequently
  setInterval(monitorTypeaheadMenus, 1000);
  
  // Listen for input events on search boxes
  document.addEventListener('input', function(e) {
    if (e.target.classList.contains('tt-input') || 
        e.target.closest('.twitter-typeahead')) {
      setTimeout(monitorTypeaheadMenus, 100);
    }
  });
  
  // Listen for focus events
  document.addEventListener('focus', function(e) {
    if (e.target.classList.contains('tt-input') || 
        e.target.closest('.twitter-typeahead')) {
      setTimeout(monitorTypeaheadMenus, 100);
    }
  }, true);
  
  // Handle suggestion clicks to force close
  document.addEventListener('click', function(e) {
    if (e.target.closest('.tt-suggestion')) {
      const menu = e.target.closest('.tt-menu');
      const input = e.target.closest('.twitter-typeahead')?.querySelector('.tt-input');
      
      if (menu && input) {
        // Get the suggestion text
        const suggestionText = e.target.textContent.trim().replace(/^[^a-zA-Z0-9]*/, '');
        
        // Set the input value
        input.value = suggestionText;
        
        // Force close the menu
        forceCloseMenu(menu);
        
        // Trigger events
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        
        // Try jQuery events if available
        if (window.$ && $(input).length) {
          $(input).trigger('change');
          $(input).typeahead('close');
        }
      }
    }
  });
  
  // Handle clicks outside typeahead to close
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.twitter-typeahead')) {
      document.querySelectorAll('.tt-menu').forEach(forceCloseMenu);
    }
  });
  
  // Expose the force close function globally
  window.forceCloseTypeahead = function(input) {
    const container = input.closest('.twitter-typeahead');
    const menu = container?.querySelector('.tt-menu');
    if (menu) {
      forceCloseMenu(menu);
    }
  };
}

// Auto-initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', initTypeaheadHelper); 